




















































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import KeyValue from "@/models/keyValue.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from "@/enums/PermissionValue";
import AcademicTitle from "@/models/academic/academicTitle.model";

@Component
export default class AcademicTitleTableComponent extends GenericBTable<
  AcademicTitle
> {
  created() {
    this.permissionValue = PermissionValue.TITULOSACADEMICOS;
    this.tableConfig.controller = "AcademicTitle";
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let key = new BTableColumn("name", "table.name", true);
    this.tableConfig.insertColumns(key);
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;

  }
}
